import styles from './FormBody.module.scss';

const FormBody = ({ children }) => <div className={styles.formBody}>{children}</div>;

export default FormBody;
